export const lineConfig = {
  stroke: "rgba(0,0,0,1)",
  strokeWidth: 2,
}
